import { useDisableMenuItems } from 'hooks/useDisableMenuItems'
import { MainLayout } from 'layouts/MainLayout'
import { ActivityHistory } from 'modules/ActivityHistory'
import { Applications } from 'modules/Applications'
import { BookingHistory } from 'modules/BookingHistory'
import { Documents } from 'modules/Documents'
import { DropoffFee } from 'modules/DropoffFee'
import { Locations } from 'modules/Locations'
import { TermsAndConditions } from 'modules/TermsAndConditions'
import { useAppSelector } from 'redux/hooks'
import { isSupplierSelector } from 'redux/login/selectors'
import { MENU_NAMES } from 'texts/menuNames'

export const LocationsRoute = () => {
  const { disableMenuItem } = useDisableMenuItems()

  return (
    <MainLayout
      Content={<Locations />}
      isUnavailable={disableMenuItem(MENU_NAMES.LOCATIONS)}
    />
  )
}

export const DropoffFeeRoute = () => {
  const { disableMenuItem } = useDisableMenuItems()

  return (
    <MainLayout
      Content={<DropoffFee />}
      isUnavailable={disableMenuItem(MENU_NAMES.DROP_OFF_FEE)}
    />
  )
}

export const TermsAndConditionsRoute = () => {
  const { disableMenuItem } = useDisableMenuItems()

  return (
    <MainLayout
      Content={<TermsAndConditions />}
      isUnavailable={disableMenuItem(MENU_NAMES.TERMS_AND_CONDITIONS)}
    />
  )
}

export const ActivityHistoryRoute = () => {
  const isSupplier = useAppSelector(isSupplierSelector)

  return <MainLayout Content={<ActivityHistory />} isUnavailable={isSupplier} />
}

export const ApplicationsRoute = () => {
  const isSupplier = useAppSelector(isSupplierSelector)

  return <MainLayout Content={<Applications />} isUnavailable={isSupplier} />
}

export const BookingHistoryRoute = () => {
  const { disableMenuItem } = useDisableMenuItems()

  return (
    <MainLayout
      Content={<BookingHistory />}
      isUnavailable={disableMenuItem(MENU_NAMES.BOOKING_HISTORY)}
    />
  )
}

export const DocumentsRoute = () => {
  const { disableMenuItem } = useDisableMenuItems()

  return (
    <MainLayout
      Content={<Documents />}
      isUnavailable={disableMenuItem(MENU_NAMES.DOCUMENTS)}
    />
  )
}
